// Handy: feste Reiterleiste unten (Spielen, Taktik, Bibliothek, Analyse, Mehr) und das Blatt „Mehr“ mit
// Seltenem: Foto, Brett-Editor, Wallpaper, Setup, Sprache, Vibration, als App installieren.
// Sichtbar nur unter 700 px Breite (phone.css); darüber gilt die Reiterleiste oben.
import { h, type VNode } from 'snabbdom';
import { setVibrate, vibrateOn } from '../appfeel';
import { getLang, LANGS, setLang, t } from '../i18n';
import { icon, type IconName } from '../icons';
import { canInstall, install, needsIosHint } from '../install';
import { isPublic } from '../util';

let open = false;
const MORE = ['photo', 'editor', 'wallpaper', 'setup'];

export function phoneNav(active: string, analyseHref: string, redraw: () => void): VNode {
  const tab = (href: string, label: string, ic: IconName, on: boolean) =>
    h('a.ptab', { class: { on }, attrs: { href, 'aria-current': on ? 'page' : false }, on: { click: () => (open = false) } }, [icon(ic), h('span', t(label))]);
  const more = h('button.ptab', {
    class: { on: open || MORE.includes(active) },
    attrs: { 'aria-expanded': String(open) },
    on: { click: () => ((open = !open), redraw()) },
  }, [icon('more'), h('span', t('Mehr'))]);
  return h('div.phone', [
    open ? sheet(redraw) : null,
    h('nav.phone-nav', { attrs: { 'aria-label': t('Hauptnavigation') } }, [
      tab('#/spielen', 'Spielen', 'play', active === 'play'),
      tab('#/taktik', 'Taktik', 'puzzle', active === 'puzzle'),
      tab('#/bibliothek', 'Bibliothek', 'library', active === 'library'),
      tab(analyseHref, 'Analyse', 'analyse', active === 'game' || active === 'analyse'),
      more,
    ]),
  ]);
}

function sheet(redraw: () => void): VNode {
  const close = () => ((open = false), redraw());
  const link = (href: string, label: string) => h('a', { attrs: { href }, on: { click: () => (open = false) } }, t(label));
  const canVibrate = typeof navigator !== 'undefined' && 'vibrate' in navigator;
  return h('div.sheet-wrap', { on: { click: (e: Event) => e.target === e.currentTarget && close() } }, h('div.sheet', [
    link('#/foto', 'Foto'),
    link('#/editor', 'Brett-Editor'),
    isPublic ? null : link('#/wallpaper', 'Wallpaper'),
    link('#/setup', 'Setup'),
    h('div.row.langs', [h('span', t('Sprache')), ...LANGS.map(l =>
      h('button.lang', { class: { active: getLang() === l }, attrs: { 'aria-pressed': String(getLang() === l) }, on: { click: () => (setLang(l), redraw()) } }, l.toUpperCase()))]),
    canVibrate ? h('label.chk', [
      h('input', { attrs: { type: 'checkbox' }, props: { checked: vibrateOn() }, on: { change: (e: Event) => (setVibrate((e.target as HTMLInputElement).checked), redraw()) } }),
      ' ' + t('Vibrieren, wenn der Gegner zieht'),
    ]) : null,
    canInstall() ? h('button.btn.accent', { on: { click: () => void install(redraw) } }, t('Als App installieren'))
      : needsIosHint() ? h('p.muted.small', t('Als App: in Safari „Teilen“, dann „Zum Home-Bildschirm“.')) : null,
  ]));
}
